import { Component, OnInit, OnDestroy } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from 'rxjs';
import { UserRoleState, UserRoles, Role } from '../../store/user-role/user-role-state.model';
import { NgIf } from '@angular/common';
import { UserRoleUpdateFormComponent } from '../user-role-form/user-role-update-form/user-role-update-form.component';

@Component({
    selector: 'app-user-role-side-nav',
    templateUrl: './user-role-side-nav.component.html',
    styleUrls: ['./user-role-side-nav.component.scss'],
    imports: [NgIf, UserRoleUpdateFormComponent]
})
export class UserRoleSideNavComponent implements OnInit, OnDestroy {
  /**
  *@arg Property to observe the redux customer store
  **/
  @select('userRole') readonly userRoleObservable: Observable<UserRoleState>;
  /**
  *@arg Property to determine type of sidenav
  **/
  public type: string;
  /**
  *@arg Property to get user roles and input to edit form
  **/
  public userRoles: UserRoles;
  /**
  *@arg Property to get user role list
  **/
  public roleList: Array<Role>;
  /**
  *@arg Property to determine attribute of sidenav to be updated
  **/
  public attribute: string;
  /**
   * @property to store the subscription
   */
  private subscription: Subscription;
  constructor() {}

  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.subscription = this.userRoleObservable.subscribe((userRoleStore) => {
      this.type = userRoleStore.updateRole;
      this.userRoles = userRoleStore.userRoles;
      this.roleList = userRoleStore.roleList;
    });
  }

  /**
   * @function ngOnDestroy Runs final sequence
   */
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
